import { Dialog, DialogContent, DialogTitle, Tooltip } from '@mui/material';
import styles from './yearlyMonthlyDialog.module.css';
import React from 'react';
import { useSelector } from 'react-redux';
import aszf from 'assets/files/aszf_DT_fotos.pdf';
import { useTranslation } from 'react-i18next';
const YearlyMonthlyDialog = ({ user, open, setOpen, data, assignTier, isAnnual }) => {
  const shopTier = useSelector((state) => state.nonPersistedReducers?.shopTierSliceReducer?.shopTier);
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle style={{ textAlign: 'center' }}>
        {isAnnual
          ? t('subscription.bundles.yearlyMonthly.sureYearly')
          : t('subscription.bundles.yearlyMonthly.sureMonthly')}
      </DialogTitle>
      <DialogContent style={{ textAlign: 'left' }}>
        {isAnnual ? (
          <p>
            {t('subscription.bundles.yearlyMonthly.monthly1')}
            <b>
              {t('subscription.bundles.yearlyMonthly.monthly2')}
              {user?.ownedShops[0]?.paymentData?.length > 0 &&
                user?.ownedShops[0]?.paymentData[user?.ownedShops[0]?.paymentData?.length - 1]?.dueDate?.substring(
                  0,
                  10
                )}{' '}
              {t('subscription.bundles.yearlyMonthly.monthly3')}
            </b>{' '}
            <br />
            <br />
            {t('subscription.bundles.yearlyMonthly.monthly4')}
            <b>{t('subscription.bundles.yearlyMonthly.monthly5')}</b>
            {t('subscription.bundles.yearlyMonthly.monthly6')}
            <br />
            <br /> {t('subscription.bundles.yearlyMonthly.monthly7')}
            <a target='_blank' href={aszf} rel='noreferrer'>
              {t('subscription.bundles.yearlyMonthly.monthly8')}
            </a>{' '}
            {t('subscription.bundles.yearlyMonthly.monthly9')}
          </p>
        ) : (
          <p>
            {t('subscription.bundles.yearlyMonthly.monthly10')}
            <b>
              {t('subscription.bundles.yearlyMonthly.monthly11')}
              {user?.ownedShops[0]?.paymentData?.length > 0 &&
                user?.ownedShops[0]?.paymentData[user?.ownedShops[0]?.paymentData?.length - 1]?.dueDate?.substring(
                  0,
                  10
                )}{' '}
              {t('subscription.bundles.yearlyMonthly.monthly12')}
            </b>{' '}
            <br />
            <br />
            {t('subscription.bundles.yearlyMonthly.monthly13')}
            <b>{t('subscription.bundles.yearlyMonthly.monthly14')}</b>
            {t('subscription.bundles.yearlyMonthly.monthly15')}
            <br />
            <br /> {t('subscription.bundles.yearlyMonthly.monthly16')}
            <a target='_blank' href={aszf} rel='noreferrer'>
              {t('subscription.bundles.yearlyMonthly.monthly17')}
            </a>{' '}
            {t('subscription.bundles.yearlyMonthly.monthly18')}
          </p>
        )}
        <div className={styles.button_wrapper}>
          <button className={styles.cancel_button} onClick={() => setOpen(false)}>
            {t('common.cancel')}
          </button>
          {/* {fetchCardRegister?.data?.data?.tokens?.find((token) => token?.isValid === true) ? ( */}
          {data?.tokens?.find((token) => token?.isValid === true) ? (
            <button
              disabled={assignTier?.isLoading}
              onClick={() => assignTier.mutate({ tierId: shopTier?.id, isAnnual: isAnnual, setOpen: setOpen })}
              className={styles.submit_button}>
              {t('subscription.bundles.yearlyMonthly.change')}
            </button>
          ) : (
            <Tooltip title={t('subscription.bundles.yearlyMonthly.changeTooltip')}>
              <button className={styles.disabled_button} onClick={() => {}}>
                {t('subscription.bundles.yearlyMonthly.change')}
              </button>
            </Tooltip>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default YearlyMonthlyDialog;
